module.exports = __webpack_public_path__ + "static/media/2DGACM7.f59e7c6d.jpg";